export { MainVisual } from "./mainvisual";
export { ServiceLinks } from "./servicelinks";
export { DataInfo } from "./datainfo";
export { News } from "./news";
export { Press } from "./press";
export { Partners } from "./partners";
